var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#003087"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7487 12.6676L17.3324 11.2513L8.00325 20.5804V21.9967H9.41955L18.7487 12.6676ZM20.165 11.2513L21.5813 9.83501L20.165 8.41871L18.7487 9.83501L20.165 11.2513ZM10.2489 24H6V19.7501L19.4568 6.29326C19.6447 6.10549 19.8994 6 20.165 6C20.4306 6 20.6853 6.10549 20.8731 6.29326L23.7067 9.12686C23.8945 9.31469 24 9.56942 24 9.83501C24 10.1006 23.8945 10.3553 23.7067 10.5432L10.2489 24Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.a9c478296577e04b073280dcffd5d846.svg";
export { ForwardRef as ReactComponent };